import axios from 'axios';

const defaultHeaders = {
  'Content-Type': 'application/json',
};

const Axios = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PROD_URL : process.env.REACT_APP_DEV_URL,
  timeout: 30000,
  headers: defaultHeaders,
});

export default Axios;
